import { DEFAULT_IMAGE } from '@/utils/const';

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
    };
  },
  methods: {
    /**
         * Change users
         */
    changeUser () {
      this.$root.$emit('notification', {
        message: 'In developing',
        type: 'attention',
        show: true,
      });
    },

    /**
         * Remove users
         */
    removeUserHolder () {
      return this.$root.$emit('notification', {
        message: 'In developing',
        type: 'attention',
        show: true,
      });
    },
  },
};
